import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { ReplayCircleFilled, SvgIconComponent } from "@mui/icons-material";
import {
  Box,
  IconProps,
  SvgIconProps,
  SxProps,
  Tooltip,
  TooltipProps,
} from "@mui/material";
import { AppIconsReplaced } from ".";

export type ReplaceIconProps = {
  title?: string;
  sx?: SxProps | undefined;
  propsToolTipCSS?: React.CSSProperties;
  propsToolTip?: TooltipProps;
  propsIcon?: SvgIconProps;
};

const ReplaceIcon = function (props: ReplaceIconProps) {
  const newPropsIcon = props.propsIcon || { fontSize: "small" };

  return (
    <Box sx={props.sx}>
      <Tooltip
        title={props.title}
        {...props.propsToolTip}
        sx={props.propsToolTipCSS}
        placement="top"
      >
        <AppIconsReplaced {...newPropsIcon} />
      </Tooltip>
    </Box>
  );
};
export default ReplaceIcon;
